import AsyncLoader from 'component/AsyncLoader';

export const PublishTask =  AsyncLoader(() => import('./PublishTask'));
export const TaskList =  AsyncLoader(() => import('./TaskList'));
export const TemplateList =  AsyncLoader(() => import('./TemplateList'));
export const TemplateDetail =  AsyncLoader(() => import('./TemplateList/TemplateDetail'));
export const RecruitmentInfo =  AsyncLoader(() => import('./TaskList/RecruitmentInfo'));